import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import {
  ApiService,
  Appointment,
  AppointmentModel,
  Patient,
  paymentDisplayStatus,
  paymentStatusColor,
} from '@mmx/shared'

@Component({
  selector: 'mmx-payment-status-icon',
  templateUrl: './payment-status-icon.component.html',
  standalone: false,
})
export class PaymentStatusIconComponent {
  @Input() patient?: Patient
  @Input() appointment?: AppointmentModel
  @Input() status?: Appointment.PAYMENT_STATUS
  @Input() workflow = false

  public PAYMENT_STATUS = Appointment.PAYMENT_STATUS
  public inProgress = false
  public paymentStatusColor = paymentStatusColor
  public paymentDisplayStatus = paymentDisplayStatus

  constructor(private router: Router, private restService: ApiService) {}

  menuOpened() {
    if (
      this.appointment &&
      this.appointment.invoices == null &&
      !this.inProgress
    ) {
      this.inProgress = true

      this.restService.getAppointment(this.appointment.id).subscribe(
        (appointment) => {
          this.inProgress = false
          this.appointment = appointment

          if (this.appointment.invoices == null) {
            this.appointment.invoices = []
          }
        },
        () => {
          this.inProgress = false
        },
      )
    }
  }

  goto(...url: string[]) {
    this.router.navigate(url)
  }
}
